import { render } from "./ModalConfirmaAgape.vue?vue&type=template&id=3c093289&scoped=true"
import script from "./ModalConfirmaAgape.vue?vue&type=script&lang=js"
export * from "./ModalConfirmaAgape.vue?vue&type=script&lang=js"

import "./ModalConfirmaAgape.vue?vue&type=style&index=0&id=3c093289&scoped=true&lang=css"

import exportComponent from "D:\\FOP\\AGAPE\\AGAPE_HOSPITALAR\\ReguaHospitalar\\frontendRegua\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c093289"]])

export default __exports__